import { render, staticRenderFns } from "./ViewDeprecationMassive.vue?vue&type=template&id=39e7116c&scoped=true"
import script from "./ViewDeprecationMassive.vue?vue&type=script&lang=js"
export * from "./ViewDeprecationMassive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e7116c",
  null
  
)

export default component.exports